import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { OrderCountGreaterThanState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/order-count_greater_than";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const OrderCountGreaterThanDetails = memo(
  function OrderCountGreaterThanDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<OrderCountGreaterThanState>) {
    return (
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Minimum orders
        </Text>
        <RedoTextInput
          min={0}
          placeholder="Enter minimum number..."
          setValue={setState}
          state={disabled ? "readonly" : "default"}
          value={state}
        />
      </Flex>
    );
  },
);
